import React from 'react'
import { Waypoint } from 'react-waypoint'
import { makeStyles } from '@material-ui/core/styles'

const styles = theme => ({
    root: {
        marginTop: props => props.top,
        position: props => props.absolute ? 'absolute' : 'static',
        top: props => props.y,
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1000)]: {
            top: props => props.yMobile
        }
    }
})

const useStyles = makeStyles(styles)

export default function OnViewPortObserver({
    onEnterViewPort,
    top,
    absolute,
    yMobile,
    y
}) {
    // props of positioned absolute elem, if for ex u want a text appear in the middle of the viewport
    const props = { top, absolute, y, yMobile }
    const classes = useStyles(props)
    return (
        <span className={classes.root} >
            <Waypoint onEnter={onEnterViewPort} />
        </span>
    )
}
